// CHUẨN VIẾT NGÀY BẰNG SỐ của HỆ — MỘT nguồn cho cả kernel.
//
// Sếp Phú 03/10/2026 (soi hồ sơ việc Site Connect bản tiếng Anh): «Due» in `2026-09-28`, «Start» in
// `28/09/2026` — hai ô đứng cạnh nhau hai kiểu. Gốc: «Due» đi `fmtDate` theo NGÔN NGỮ (en-CA của CLDR viết
// ngày số kiểu ISO yyyy-mm-dd), «Start» của ca ghép tay `dd/mm/yyyy`. Sếp chốt: thứ tự ngày–tháng là chuẩn
// của HỆ, không phải của ngôn ngữ —
//   · Site Connect (khách Canada, quen Connecteam) → mm/dd/yyyy
//   · CNV Work + Core (người dùng Việt)             → dd/mm/yyyy
// Đổi ngôn ngữ hiển thị KHÔNG đảo thứ tự: người Canada đọc «09/08» là 8 tháng 9, một màn mà đổi tiếng là đảo
// ngày thì ai cũng đọc nhầm ngày — sai NGÀY chứ không chỉ sai chữ.
//
// Host khai lúc khởi động: `initI18n({ dateOrder: 'mdy' })` (Connect). Không khai ⇒ 'dmy'.
// ⚠️ KHÔNG đọc `@host/tenant` ở đây: console của Work + Connect nạp `@cnv/ui/i18n` mà không có alias đó.

let thuTu = 'dmy';

/** 'mdy' | 'dmy' — giá trị lạ rơi về 'dmy'. */
export function setDateOrder(order) {
  thuTu = order === 'mdy' ? 'mdy' : 'dmy';
}

export function getDateOrder() {
  return thuTu;
}

/** Ghép ngày · tháng (· năm) theo chuẩn của hệ — `yyyy` rỗng ⇒ chỉ ngày + tháng. */
export function joinDateParts(dd, mm, yyyy) {
  const dm = thuTu === 'mdy' ? `${mm}/${dd}` : `${dd}/${mm}`;
  return yyyy ? `${dm}/${yyyy}` : dm;
}
